import * as React from 'react';
import b_ from 'b_';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';

import './index.scss';

interface Props {
  className?: string;
  canReject?: boolean;
}

type Enhanced = Props & InjectedTranslateProps;

const b = b_.with('order-card-notice');

const HaveOrderNotice: React.FC<Enhanced> = ({ t, className, canReject }) => (
  <div className={className}>
    <div className={b()}>
      <div className={b('primary-text')} data-testid="have-order-notice">
        {t('You already submit order')}
      </div>
      {canReject && (
        <div className={b('secondary-text')} data-testid="have-order-secondary-text">
          {t('Reject and create new order to change amount')}
        </div>
      )}
    </div>
  </div>
);

export default translate(HaveOrderNotice);
